import { stableHash64 } from '../model/hash';

/**
 * Deterministic hint selection.
 *
 * The suggestion is a pure function of the level seed, the remaining arrows and how many
 * hints have already been taken. Asking twice for the same board state therefore returns
 * the same arrow (no re-rolling), while a changed board yields a fresh suggestion.
 */
export function chooseHint(
  rootSeedHex: string,
  remainingArrowIds: readonly number[],
  removableArrowIds: readonly number[],
  hintCount: number,
): number {
  if (removableArrowIds.length === 0) return -1;

  // Fold the remaining set into the hash so the hint tracks board state, not tap count.
  let stateHash = stableHash64(rootSeedHex, 'hint.state', remainingArrowIds.length);
  for (const id of remainingArrowIds) {
    stateHash = stableHash64(stateHash, id);
  }
  const selector = stableHash64(stateHash, 'hint.pick', hintCount);
  const index = Number(selector % BigInt(removableArrowIds.length));
  return removableArrowIds[index];
}
